import { Button } from 'src/components/ui/button';

export const ConfigurationSettingsAddNewPromptBuilder = ({
  onCreate = (() => {}) as (isManual: boolean) => void,
  close = () => {},
}) => {
  const onClick = () => {
    close();
    onCreate(false);
  };

  return (
    <div
      className={
        'relative overflow-hidden flex flex-1 flex-col h-full min-w-[250px] max-w-[300px] items-center justify-between p-5 pt-8 pb-0 gap-3.5 border border-[#E3E6E8] rounded-sm-5 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]'
      }
    >
      <div className={'absolute -top-[2px] w-full text-center'}>
        <span
          className={
            'bg-[#A498FF1A] rounded-b-[5px] py-[3px] px-[9px] text-violet font-semibold text-base-xs'
          }
        >
          recommended
        </span>
      </div>
      <div className={'w-full flex flex-col items-center gap-2.5'}>
        <div className={'flex flex-col gap-1'}>
          <p className={'text-ebony_opacity_80 text-base font-semibold text-center'}>
            Use System Prompt Builder
          </p>
          <p className={'text-ebony_opacity_50 text-sm font-medium text-center'}>
            Create the system prompt via a guided setup flow.
          </p>
        </div>
      </div>
      <div className={'w-full flex flex-col items-center'}>
        <Button className={'w-full'} onClick={onClick}>
          Create
        </Button>
      </div>
      <div className={'flex'}>
        <img
          alt={'System Prompt Builder'}
          className={'w-full'}
          src={'/images/configuration/system_prompt_builder.webp'}
        />
      </div>
    </div>
  );
};
